module.exports = __webpack_public_path__ + "img/HA1511-01.704eadfc.jpg";